import type { StaticRemote } from '@cosmica-shell-ui/shell-shared'

export const remoteMap: StaticRemote[] = [
  {
    name: 'mind',
    entry: `${import.meta.env.VITE_MIND_URL}/remoteEntry.js`, // URL del tuo MFE
    enabled: true
  },
  {
    name: 'mifi',
    entry: `${import.meta.env.VITE_MIFI_URL}/remoteEntry.js`,
    enabled: true
  },
  {
    name: 'sam',
    entry: `${import.meta.env.VITE_SAM_URL}/remoteEntry.js`,
    enabled: true
  },
  {
    name: 'sand',
    entry: `${import.meta.env.VITE_SAND_URL}/remoteEntry.js`,
    enabled: true
  },
  {
    name: 'process',
    entry: `${import.meta.env.VITE_MAD_PROCESS_SERVICE_URL}/remoteEntry.js`, // URL del tuo MFE
    enabled: true
  },
  {
    name: 'seed',
    entry: `${import.meta.env.VITE_SEED_URL}/remoteEntry.js`, // URL del tuo MFE
    enabled: true
  },
  {
    name: 'mindwo',
    entry: `${import.meta.env.VITE_MINDWO_URL}/remoteEntry.js`, // URL del tuo MFE
    enabled: true
  },
  // showcases
  {
    name: 'sample-product',
    entry: `${import.meta.env.VITE_SAMPLE_SHOWCASE_URL}/remoteEntry.js`,
    enabled: false
  },
  {
    name: 'wf-showcase-frontend',
    entry: `${import.meta.env.VITE_WF_SHOWCASE_URL}/remoteEntry.js`, // URL del tuo MFE
    enabled: false
  }
  /*{
    name: 'angular',
    entry: 'http://localhost:4200/remoteEntry.js', // URL del tuo MFE
    enabled: true
  }*/
]
